// @ts-nocheck
/* Elemence global runtime
   Scroll-reveal: matches the React reference 1:1.
     - IntersectionObserver with threshold 0.12 (no rootMargin) — element
       must be at least 12% visible before `.in` is added.
     - Re-scans on Shopify theme-editor lifecycle events so newly inserted
       sections animate too.
     - Graceful fallback when IntersectionObserver is unavailable.
     - Safety net (3s after load): force-reveal anything that's already
       reasonably visible but still missing `.in` — covers edge cases like
       hash-anchor navigation or collapsed-then-expanded ancestors. */
(function () {
  if (window.__elemenceReveal) {
    if (typeof window.elemenceRevealScan === 'function') {
      window.elemenceRevealScan(document);
    }
    return;
  }
  window.__elemenceReveal = true;

  var hasIO = typeof IntersectionObserver !== 'undefined';
  var THRESHOLD = 0.12;

  function showAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      el.classList.add('in');
    });
  }

  // No IntersectionObserver — reveal everything immediately so content is
  // always visible. Better than animations never firing.
  if (!hasIO) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { showAll(document); });
    } else {
      showAll(document);
    }
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    }
  }, { threshold: THRESHOLD });

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.reveal:not(.in)');
    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
  }

  // Compute visible fraction of an element relative to the viewport.
  // Mirrors IntersectionObserver's intersectionRatio for the safety net.
  function visibleRatio(el) {
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return 0;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var vw = window.innerWidth  || document.documentElement.clientWidth  || 0;
    var visH = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    var visW = Math.max(0, Math.min(r.right,  vw) - Math.max(r.left, 0));
    var visArea = visH * visW;
    var elArea  = r.width * r.height;
    return elArea > 0 ? visArea / elArea : 0;
  }

  function safetyReveal() {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      if (visibleRatio(el) >= THRESHOLD) {
        el.classList.add('in');
        try { io.unobserve(el); } catch (e) {}
      }
    });
  }

  function boot() {
    scan(document);
    // 3s safety net — matches original threshold so we don't mass-reveal
    // hidden content prematurely.
    setTimeout(safetyReveal, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Second pass on `load` — late images can shift layout and bring new
  // elements into view that weren't there at DOMContentLoaded.
  window.addEventListener('load', function () { scan(document); });

  // Shopify theme-editor lifecycle
  document.addEventListener('shopify:section:load',    function (e) { scan(e.target); });
  document.addEventListener('shopify:section:reorder', function ()  { scan(document); });
  document.addEventListener('shopify:section:select',  function (e) { scan(e.target); });
  document.addEventListener('shopify:block:select',    function (e) { scan(e.target); });

  window.elemenceRevealScan = scan;
})();
